import { Banner } from '../home/Banner';
import dataNosotros from '../../utils/data-pages/data-nosotros.json';
import { InfoNosotros } from './InfoNosotros';
import { SectionAnimation } from '../utils/AnimationFramerMotion';
import { MapComponent } from '../utils/MapComponent';
import { useState } from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { FaPhone } from 'react-icons/fa6';
import { IoMapSharp } from 'react-icons/io5';
import dataHome from '../../utils/data-pages/data-home.json';
import { CardBrand } from '../home/Body';

export function PageNosotros() {
    return (
        <section className='we'>
            <div className='we__banner'>
                {
                    dataNosotros.map((item, index) => (
                        <Banner
                            key={index}
                            data={item} />
                    ))
                }
            </div>

            <div className='bg-section-primary'>
                <SectionAnimation
                    translateX='400px'
                >
                    <div className='we__info d-flex align-items-center'>
                        {
                            dataNosotros.map((item, index) => (
                                <InfoNosotros
                                    key={index}
                                    data={item} />
                            ))
                        }
                    </div>
                </SectionAnimation>
            </div>

            <div className='bg-section-secondary'>
                <SectionAnimation
                    translateX='-400px'
                >
                    {
                        dataNosotros.map((item, index) => (
                            <SectionGallery
                                key={index}
                                data={item} />
                        ))
                    }
                </SectionAnimation>
            </div>

            <div className='bg-section-primary'>
                <SectionAnimation
                    translateX='200px'
                >
                    {
                        dataHome.map((data, index) => (
                            <div className='body-home__brands py-5 d-flex align-items-center' key={index}>
                                <div className='body-home__brands__container container'>
                                    <h3 className='body-home__brands__title text-center'>{data.brandsTitle}</h3>
                                    <p className='body-home__brands__description text-center mb-4 mb-lg-5'>{data.brandsDescription}</p>
                                    <div className='body-home__brands__box row justify-content-center'>
                                        {
                                            data.brands.map((item, index) => (
                                                <CardBrand
                                                    key={index}
                                                    data={item}
                                                />
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </SectionAnimation>
            </div>

            <div className='bg-section-secondary'>
                <SectionAnimation
                    translateX='400px'
                >
                    <SectionMap />
                </SectionAnimation>
            </div>
        </section>
    );
}

export function SectionGallery({ data }) {
    return (
        <div className='we-gallery container py-5 py-lg-0 d-flex justify-content-center align-items-center'>
            <div className='we-gallery__body row w-100'>
                <div className='we-gallery__text col-12 col-lg-6 order-lg-2 ps-lg-5 d-flex flex-column justify-content-center'>
                    <p className='we-gallery__label mb-3 mb-lg-4 text-center text-lg-start'>{data.galleryLabel}</p>
                    <h4 className='we-gallery__title mb-3 mb-lg-5 text-center text-lg-start'>{data.galleryTitle}</h4>
                    <p className='we-gallery__description mb-0 text-center text-lg-start'>{data.galleryDescription}</p>
                </div>
                <div className='we-gallery__images col-12 col-lg-6 order-lg-1'>
                    <div className='we-gallery__images-box row justify-content-between'>
                        {
                            data.galleryImages.map((item, index) => (
                                <div key={index} className='we-gallery__img col-12 col-sm-6 mb-4'>
                                    <div className='contenedor position-relative w-100 h-100 d-flex align-items-center'>
                                        <img className='we-gallery__image w-100 position-relative' src={item} alt="Imagen de galería" loading='lazy' />
                                        <div className='we-gallery__image-background position-absolute bg-section-primary w-100'></div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export function SectionMap() {
    const [userLocation, setUserLocation] = useState(null);

    const showLocationUser = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setUserLocation([latitude, longitude]);
                },
                (error) => {
                    console.error('Error obteniendo la ubicación:', error);
                }
            );
        } else {
            alert('Geolocalización no es soportada por tu navegador.');
        }
    }

    return (
        <div className='we__map container py-5 py-lg-0 d-flex flex-column justify-content-center align-items-center'>
            <div className='we__map__box row w-100'>
                <div className='we__map__col col-12 col-lg-5 px-0'>
                    <div className='we__map__box col-12 col-lg-10 h-100 d-flex flex-column align-items-center'>
                        <h4 className='we__map__title mb-4 mb-lg-5'>UBICANOS</h4>
                        <div className='we__map__card w-100 mb-4 order-lg-2'>
                            {
                                dataNosotros.map((item, index) => (
                                    <CardMap
                                        key={index}
                                        infoMap={item.infoMap} />
                                ))
                            }
                        </div>
                        <button className='we__map__btn w-100 mb-4 order-lg-1' onClick={showLocationUser}>
                            <FaMapMarkerAlt
                                className='we__map__btn-icon me-2 mb-1' />
                            Usar ubicación actual
                        </button>
                    </div>
                </div>
                <div className='we__map__col col-12 col-lg-7 px-0'>
                    {
                        dataNosotros.map((item, index) => (
                            <MapComponent
                                key={index}
                                userLocation={userLocation}
                                data={item.infoMap} />
                        ))
                    }
                </div>
            </div>
        </div>
    );
}

export function CardMap({ infoMap }) {
    return (
        <div className='card-map d-flex flex-column align-items-center'>
            <p className='card-map__title mb-2 mb-md-4'>{infoMap.companyName}</p>
            <p className='card-map__address mb-0'>
                <FaMapMarkerAlt
                    className='card-map__address-icon me-1' />
                {infoMap.companyAddress}
            </p>
            <a className='card-map__phone mb-3 mb-lg-4' href={`tel:+51${infoMap.companyName}`}>
                <FaPhone
                    className='card-map__phone-icon me-1' />
                {infoMap.companyPhone}
            </a>
            <a className='card-map__btn-google w-100 text-center' href='https://www.google.com/maps?q=-7.173253,-78.511372' target='_blank' rel='noreferrer'>
                <IoMapSharp
                    className='card-map__btn-google-icon me-2' />
                Ir a Google Maps
            </a>
        </div>
    );
}